import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { FinalizeOrderComponent } from './finalize-order.component';
import { ComponentsModule } from 'src/app/shared/components/components.module';
import { SharedModule } from '@shared/shared.module';
import { FinalizeOrderFormComponent } from './finalize-order-form/finalize-order-form.component';

@NgModule({
  imports: [CommonModule, SharedModule, ReactiveFormsModule, ComponentsModule],
  declarations: [FinalizeOrderComponent, FinalizeOrderFormComponent]
})
export class FinalizeOrderModule {}
